type MaybeName = { Name?: string | null } | null | undefined;

export const getDerivedName = (primary?: string | null, fallback?: MaybeName): string => {
  if (primary && primary.trim().length > 0) {
    return primary;
  }

  return fallback?.Name ?? "";
};

export const getDerivedBoolean = (primary?: boolean | null, fallback?: boolean | null): boolean => {
  if (typeof primary === "boolean") {
    return primary;
  }

  return Boolean(fallback);
};

export const getDerivedDate = (primary?: string | Date | undefined, fallback?: string | Date | undefined): string | Date | undefined => {
  return primary ?? fallback ?? undefined;
};

